/**
 * Reports-page "Sync Dropbox" — the legacy PDF checklist import.
 * The folder panel is a different path and does not use this.
 */

import { ApiError } from '../api.js';

export const LEGACY_DROPBOX_IMPORT_OFF_MESSAGE =
  'PDF checklist import switched off from 26 Oct. Reports now come from the field app.';

/** Hidden only when the session profile explicitly says the import is off. */
export function legacyDropboxSyncVisible(enabled: boolean | undefined): boolean {
  return enabled !== false;
}

export function messageForLegacyImportFailure(error: unknown, fallback: string): string {
  if (
    error instanceof ApiError &&
    (error.status === 410 || error.body?.includes('legacy-import-disabled') === true)
  ) {
    return LEGACY_DROPBOX_IMPORT_OFF_MESSAGE;
  }
  return fallback;
}

export function SyncDropboxButton(props: {
  enabled: boolean | undefined;
  running: boolean;
  onClick: () => void;
}): JSX.Element | null {
  if (!legacyDropboxSyncVisible(props.enabled)) return null;
  return (
    <button
      type="button"
      className="ghost-btn"
      onClick={props.onClick}
      disabled={props.running}
      title="Import reports from legacy Dropbox job folders for booked jobs that have no report yet"
    >
      {props.running ? 'Syncing…' : 'Sync Dropbox'}
    </button>
  );
}
